import {Component, OnInit} from '@angular/core';
import {FaqCategory} from '../../../model/FaqCategory';
import {FaqCategoryService} from '../../../services/faq-category.service';
import {UserRequest} from '../../../model/UserRequest';
import {UserService} from '../../../services/user.service';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from "@angular/common";
import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {RouterLink} from "@angular/router";
import {Observable} from "rxjs";
import {RequestTypePipe} from "../../../components/common/RequestTypePipe";
import {DynamicModalFormComponent} from "../../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';
import { DynamicTableComponent } from 'src/app/components/common/dynamic-table/dynamic-table.component';

@Component({
    selector: 'app-users-history',
    imports: [
        CommonModule,
        BreadcrumbComponent,
        FaIconComponent,
        RouterLink,
        RequestTypePipe,
        NgbTooltip,
        BadgeComponent,
        SpinnerComponent,
        DynamicModalFormComponent,
        DynamicTableComponent
    ],
    templateUrl: './users-history.component.html',
    styleUrls: ['./users-history.component.css']
})
export class UsersHistoryComponent implements OnInit {

  requests: Observable<UserRequest[]>;
  categories: FaqCategory[];

  toView: UserRequest;

  tableHeaders = [
    {
      label: 'État'
    },
    {
      label: 'Date de la demande',
      sortable: true,
      property: 'date',
    },
    {
      label: 'Nom',
      sortable: true,
      property: 'coords.lastname',
      customSort: (a, b) => a.coords.lastname.localeCompare(b.coords.lastname),
    },
    {
      label: 'Prénom',
      sortable: true,
      property: 'coords.firstname',
      customSort: (a, b) => a.coords.firstname.localeCompare(b.coords.firstname),
    },
    {
      label: 'Adresse mail',
      sortable: true,
      property: 'coords.email',
      customSort: (a, b) => a.coords.email.localeCompare(b.coords.email),
    },
    {
      label: 'Logiciels'
    },
  ]


  constructor(private userRequest: UserService,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.faqCategoryService.getObjects().subscribe(cats => {
      this.categories = cats;
    });

    this.requests = this.userRequest.listRequests();
  }

  getCategoryFromSlug(p: any): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.toLowerCase();
    });
  }

  viewReason(request: UserRequest): void {
    this.toView = Object.assign({}, request);
  }

}
